export default __webpack_public_path__ + "static/media/ebirr.e4b09240.png";